import React, { ReactElement } from 'react'
import { Flex, Text } from 'theme-ui'
import { Svg } from 'ui'
import TestimonialIcon from 'images/organization/homepage/sections/whatPeopleSay/testimonial-icon.svg'
import BlurIcon from 'images/organization/homepage/sections/whatPeopleSay/blur-testimonial.svg'
import LargeBackgroundLogo from 'images/organization/homepage/sections/whatPeopleSay/large-background-logo-left.svg'
import TestimonialCarousel from 'components/Organization/HomePage/Sections/WhatPeopleSay/TestimonialCarousel'
import useBreakpointIndex from 'ui/Theme/useBreakpointIndex'

export default function WhatPeopleSay(): ReactElement {
  const isDesktop = useBreakpointIndex() === 2

  return (
    <Flex
      data-testid="what-people-say-about-control-d-section"
      className="ios-scrolling-glitches-fix"
      sx={{
        width: '100%',
        justifyContent: 'center',
        backgroundColor: 'blue800',
        pt: ['6.4rem', 0],
        position: 'relative',
      }}
    >
      <Flex
        className="ios-scrolling-glitches-fix"
        sx={{
          position: 'absolute',
          width: '100%',
          height: ['40%', '32rem'],
          zIndex: 0,
          background: 'rgba(246, 102, 255, 0.10)',
          filter: 'blur(75px)',
        }}
      />

      {isDesktop && (
        <Svg
          svg={LargeBackgroundLogo}
          descriptiveText="Decorative background logo"
          sx={{
            position: 'absolute',
            zIndex: 'zIndex0',
            top: 0,
          }}
        />
      )}

      <Flex
        sx={{
          width: '100%',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          zIndex: 'zIndex10',
          pb: ['6.4rem', '2rem', '10rem'],
          maxWidth: '112rem',
        }}
      >
        <Flex sx={{ flexDirection: 'column', alignItems: 'center', mb: ['4rem', '7.2rem'] }}>
          <Flex
            className="ios-scrolling-glitches-fix"
            sx={{
              position: 'relative',
              mb: '3.2rem',
              py: 0,
              justifyContent: 'center',
              alignItems: 'center',
              height: '7.8rem',
            }}
          >
            <Flex
              className="ios-scrolling-glitches-fix"
              sx={{
                position: 'absolute',
                borderRadius: '50%',
                width: '7.8rem',
                height: '7.8rem',
                justifyContent: 'center',
                alignItems: 'center',
                background:
                  'linear-gradient(180deg, rgba(161, 87, 255, 0.1) 0%, rgba(161, 87, 255, 0.00) 100%)',
              }}
            />

            <svg
              width="80"
              height="80"
              style={{
                position: 'absolute',
                transform: 'rotate(30deg)',
                WebkitTransform: 'translateZ(0)',
                contentVisibility: 'auto',
              }}
            >
              <linearGradient id="linearColors" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0%" stopColor="rgba(161, 87, 255, 0.2)"></stop>
                <stop offset="100%" stopColor="rgba(161, 87, 255,0)"></stop>
              </linearGradient>
              <circle
                r="38"
                cx="40"
                cy="39"
                className="external-circle"
                strokeWidth="1"
                fill="none"
                stroke="url(#linearColors)"
              ></circle>
            </svg>
            <Svg
              svg={BlurIcon}
              sx={{
                position: 'absolute',
                WebkitTransform: 'translateZ(0)',
                contentVisibility: 'auto',
              }}
              descriptiveText="Blur effect for testimonial icon"
            />
            <Svg
              svg={TestimonialIcon}
              sx={{
                width: '3.2rem',
                height: '2.99rem',
                WebkitTransform: 'translateZ(0)',
                contentVisibility: 'auto',
              }}
              descriptiveText="Testimonial section icon"
            />
          </Flex>
          <Text
            sx={{
              color: 'aliceBlue',
              fontSize: ['2.8rem', '4rem'],
              px: '1.6rem',
              fontWeight: 600,
            }}
            as="h2"
          >
            What people say about Control D
          </Text>
        </Flex>
        <TestimonialCarousel />
      </Flex>
    </Flex>
  )
}
